import { useField } from '@framework/form';
import { useCallback, useMemo } from 'react';
import { StaticBooleanConditionSchema } from '../../../../../../../inputs/expressions-editor/conditions/BooleanConditionSchema';
import { toAdvancedRichText } from '../../../../../../../inputs/rich-text-advanced/render/toAdvancedRichText';
import { useTreeReferencesContext } from '../../../../../../../tree/references/TreeReferencesContext';
import { Datatype } from '../../../../../../expressions/datatype/Datatype';
import { ReferenceType } from '../../../../../../expressions/references/IReference';
import { IWidgetOption } from '../../../../../Widget';

export function useSetOptionsFromVariable(options: { fieldName: string }) {
  const field = useField<IWidgetOption[]>(options.fieldName);

  const { references } = useTreeReferencesContext();

  // Lista di variabili di tipo Register (variabili anagrafica),
  //sia in formato references che in formato options (per il select)

  const variableReferences = useMemo(() => {
    const variables = references.filter(
      reference => reference.type === ReferenceType.Register,
    );
    return {
      variables,
      options: variables.map(reference => ({
        label: reference.label,
        value: reference.id,
      })),
    };
  }, [references]);

  const setOptionsFromVariable = useCallback(
    (id: string) => {
      const variable = variableReferences.variables.find(v => v.id === id);

      if (!variable) {
        console.error(`[useSetOptionsFromVariable] La variabile selezionata non esiste`, {variableReference: variableReferences, variable}); // prettier-ignore
        return;
      }

      if (variable.type !== ReferenceType.Register) {
        console.error(`[useSetOptionsFromVariable] La variabile selezionata non è di tipo Register`, {variable}); // prettier-ignore
        return;
      }

      if (
        (variable.field.type === Datatype.Array &&
          variable.field.itemsType !== Datatype.Object) ||
        variable.field.type !== Datatype.Array
      ) {
        // Recupero la lista delle opzioni disponibili
        const variableFieldOptions = variable.field.options;
        if (!variableFieldOptions) return;

        // Creo la lista delle opzioni da assengare ai widget lista
        const optionList = variableFieldOptions.map(option => ({
          type: 'option' as const,
          visible: StaticBooleanConditionSchema.cast({}, { assert: false }),
          value: String(option.value),
          label: toAdvancedRichText(option.label),
        }));

        // Imposto le opzioni nel form di configurazione del widget sovrascrivendo quelle precedenti
        field.setValue(optionList);
      }
    },
    [field, variableReferences],
  );

  return { setOptionsFromVariable, variableReferences };
}
